import services from '@/config/services'

export default class PraticheService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_pratiche.url}` 
    this.praticheBase = `${services.ask_pratiche_base.url}` 
  }

  importaXlsx(file) {
    const url = `${this.praticheBase}/api/sospensioni/non-sospendibili/upload`;
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}